import React from 'react';
import { STRING_ANY_HASH, STRING_STRING_HASH } from '@chiroup/core';
import classNames from 'classnames';

type Props = {
  hash: STRING_ANY_HASH | null | undefined;
  valueClassNames?: STRING_STRING_HASH | null | undefined;
  header?: string | null;
  headerComponentRight?: React.ReactNode;
};
export const HashDisplay: React.FC<Props> = ({
  hash,
  header = null,
  valueClassNames = {},
  headerComponentRight = null,
}) => {
  if (!hash) return null;
  const colors = ['bg-white', 'bg-primary-100'];

  return (
    <div
      className={classNames(
        'mx-8 mt-8 mb-4 border border-gray-400',
        header ? 'rounded-t-lg' : '',
      )}
    >
      {header ? (
        <div
          className={classNames(
            'text-gray-800 px-3 py-1 font-bold text-md border-b-2 border-gray-300 rounded-t-lg bg-gray-300 flex justify-center',
          )}
        >
          <div>{header}</div>
          {headerComponentRight ? headerComponentRight : null}
        </div>
      ) : null}
      {Object.entries(hash).map(([key, value], idx) => {
        return (
          <div
            className={classNames('grid grid-cols-2', colors[idx % 2])}
            key={key}
          >
            <div className="px-4 py-2 italic text-sm">{key}</div>
            <div className={valueClassNames?.[key] ?? 'px-4 py-2 text-sm'}>
              {value}
            </div>
          </div>
        );
      })}
    </div>
  );
};
